import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
	selector: 'app-text-area',
	templateUrl: './text-area.component.html',
	styleUrls: ['./text-area.component.scss'],
})
export class TextAreaComponent implements OnInit {
	@Input() rows = '6';
	@Input() cols = '30';
	@Input() value: string = '';
	@Input() placeholder: string = '';

	@Output() onChangeEvent = new EventEmitter<string>();
	@Output() onEnterEvent = new EventEmitter<string>();
	@Output() onFocusInEvent = new EventEmitter<string>();
	@Output() onFocusOutEvent = new EventEmitter<string>();

	constructor() {
	}

	ngOnInit(): void {
	}

	onChange(value: string) {
		this.onChangeEvent.emit(value.trim());
	}

	onEnter(value: string) {
		this.onEnterEvent.emit(value);
	}

	onFocusIn(value: string) {
		this.onFocusInEvent.emit(value);
	}

	onFocusOut(value: string) {
		this.onFocusOutEvent.emit(value);
	}
}
